import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';

export default function PrevPageLink({ page, classes, linkBuilder, format }) {
  const disabled = page < 0;
  const props = {
    className: cx(
      classes.item,
      classes.prevPage,
      {
        [classes.disabled]: disabled,
      },
    ),
    children: '',
  };
  return (
    disabled ?
      <span {...props} /> :
      <Link
        {...props}
        to={linkBuilder({ page: format(page) })}
        title={format(page)}
        data-page={page}
      />
  );
}

PrevPageLink.propTypes = {
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  classes: PropTypes.shape({
    item: PropTypes.string,
    prevPage: PropTypes.string,
    disabled: PropTypes.string,
  }).isRequired,
  linkBuilder: PropTypes.func.isRequired,
  format: PropTypes.func.isRequired,
};
